<div class="p-0">
    <mat-divider></mat-divider>
    <div class="row mt-4 mb-4">
        <div class="col-md-12">
            <span><i class="fa fa-exclamation-triangle customColor"></i>You are about to delete the
                <span class="userInfo">{{currentItem?.userInfo}}</span> Admin User</span>
            <p class="pl-4 pt-3 pb-3 mb-0"><b>Deleting the user will delete his entire user records</b></p>
            <p class="pl-4 mb-0">Are you sure you want to <span class="customColor">delete?</span></p>
        </div>
    </div> 
    <mat-divider></mat-divider>
    <div class="d-flex justify-content-end align-items-center mt-3">
    <button class="btn cancelBtn mr-4" type="button" (click)="closeDialog()">Cancel</button>
    <button class="btn btn-danger" type="button" (click)="deleteUserFormSub()">Yes, Delete it</button>
    </div>
</div>